export { defineEntity } from "./types";
export type { EntityDefinition, SynthesizeFieldFn } from "./types";

// CRM core entities
export { contactsEntity } from "./entities/contacts";
export { companiesEntity } from "./entities/companies";
export { dealsEntity } from "./entities/deals";
export { ticketsEntity } from "./entities/tickets";

// Operations entities
export { timeEntriesEntity } from "./entities/time-entries";
export { tasksEntity } from "./entities/tasks";
export { communicationsEntity } from "./entities/communications";

// Billing entities
export { recurringTransactionsEntity } from "./entities/recurring-transactions";
export { recurringChargesEntity } from "./entities/recurring-charges";

// Sales documents
export { contractsEntity } from "./entities/contracts";

// People & catalog entities
export { employeesEntity } from "./entities/employees";
export { adminUsersEntity } from "./entities/admin-users";
export { offeringsEntity } from "./entities/offerings";

export {
  ENTITY_REGISTRY,
  ENTITY_REGISTRY_KEYS,
  getEntityDefinition,
  getEntityTableConfig,
  getEntityDetailConfig,
  isEntityRegistryKey,
  resolveEntityDisplayName,
} from "./registry";
export type { EntityRegistryKey } from "./registry";

export {
  ENTITY_CONSTANTS,
  ENTITIES_WITH_CONSTANTS,
  getEntityConstants,
  hasEntityConstants,
} from "./constants";
export type {
  EntityConstantsMap,
  EntityConstantsKey,
  CompanyEntityConstants,
  TimeEntryEntityConstants,
  TicketEntityConstants,
  TaskEntityConstants,
} from "./constants";

export { useRegistryConfigEnhancer } from "./hooks/useRegistryConfigEnhancer";

/** Entity keys that inject dynamic options via useConfigEnhancer at render time. */
export const ENTITIES_WITH_CONFIG_ENHANCERS = [
  "contacts",
  "companies",
  "deals",
  "tickets",
  "tasks",
  // Marketing entities: dynamic BRAND options (brands are rows in
  // marketing_brands, not a compile-time union).
  "social_media_posts",
  "email_campaigns",
] as const satisfies readonly import("./registry").EntityRegistryKey[];
